import { WidgetProps } from "@rjsf/core";
import { WorkflowTasks } from "components/WorkflowTasks";
import { useEffect } from "react";

export const WorkflowWidget = (props: WidgetProps) => {
    const { applicationNumber, workflowWidgetRef, onWorkflowLoaded, appSubmitted, isWorkflowTask, codeNumber } = props.formContext ?? {};

    // Setup widget
    useEffect(() => {
        if (workflowWidgetRef) {
            workflowWidgetRef.current = {
                fieldNumber: props.uiSchema["af:fieldNumber"],
            };
        }

        return () => {
            if (workflowWidgetRef?.current) {
                workflowWidgetRef.current = undefined;
            }
        };
    }, [props.uiSchema, workflowWidgetRef]);

    if (isWorkflowTask || appSubmitted) {
        return null;
    }

    return (
        <div className="workflow-widget py-2">
            <WorkflowTasks applicationNumber={applicationNumber} onWorkflowLoaded={onWorkflowLoaded} codeNumber={codeNumber} />
        </div>
    );
};
